import { render, staticRenderFns } from "./liveRoomList.vue?vue&type=template&id=531666bd&scoped=true&"
import script from "./liveRoomList.vue?vue&type=script&lang=ts&"
export * from "./liveRoomList.vue?vue&type=script&lang=ts&"
import style0 from "./liveRoomList.vue?vue&type=style&index=0&id=531666bd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531666bd",
  null
  
)

export default component.exports